module.exports = "/images/match-active.svg?0c050d8c2cf886dfb20892e7e0836236";